import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import socioService from "../services/socioService.tsx";
import { useAuth } from "../context/AuthProvider.tsx";
import Loading from "./Loading.tsx";

export default function RequireSelectedSocio() {
  const { isAuthenticated, isLoading: authLoading, getAccessTokenSilently, user } = useAuth0();
  const { isAdmin } = useAuth();
  const [checking, setChecking] = useState(true);
  const [hasSocio, setHasSocio] = useState(false);

  useEffect(() => {
    const ensureSocio = async () => {
      if (authLoading) return;
      if (!isAuthenticated) {
        setChecking(false);
        setHasSocio(false);
        return;
      }

      // Si ya hay socio seleccionado, seguimos sin tocar nada.
      const selected = socioService.getSelectedSocioFromLocalStorage();
      if (selected?.socio_id) {
        setHasSocio(true);
        setChecking(false);
        return;
      }

      // Intento 1: autoselección desde socios cacheados.
      const auto = socioService.autoSelectSingleSocio();
      if (auto?.socio_id) {
        setHasSocio(true);
        setChecking(false);
        return;
      }

      // Intento 2: refrescar socios desde backend y autoseleccionar si hay uno solo.
      try {
        if (user?.email) {
          const socios = await socioService.getUserProfile(String(user.email), getAccessTokenSilently);
          if (Array.isArray(socios) && socios.length) {
            socioService.saveSociosInLocalStorage(socios);
            if (socios.length === 1) {
              socioService.saveSelectedSocioInLocalStorage(socios[0]);
              setHasSocio(true);
              setChecking(false);
              return;
            }
          }
        }
      } catch (error) {
        console.warn("No se pudo validar socio seleccionado", error);
      }

      setHasSocio(false);
      setChecking(false);
    };

    ensureSocio();
  }, [authLoading, isAuthenticated, user, getAccessTokenSilently]);

  if (authLoading || checking) return <Loading />;
  if (!isAuthenticated) return <Loading />;

  if (hasSocio || isAdmin) return <Outlet />;

  return <Navigate to="/seleccionar-socio" replace />;
}
